// extracted by mini-css-extract-plugin
module.exports = {"list":"list--3uqXk","procurement":"procurement--2pat_","ant-tabs-nav":"ant-tabs-nav--23Zkq","col":"col--3dT6r","label":"label--aycQF","colRight":"colRight--22S9N"};